export default __webpack_public_path__ + "static/media/audio_24_Fogata.34f1f15e.mp3";